import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Home, Upload } from 'lucide-react';

export function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-20 h-20 bg-danger-100 rounded-full flex items-center justify-center mb-8">
          <AlertTriangle className="h-10 w-10 text-danger-600" />
        </div>
        
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.
        </p>
        
        <div className="space-y-4">
          <Link
            to="/"
            className="w-full btn btn-primary"
          >
            <Home className="h-5 w-5 mr-2" />
            Go to Homepage
          </Link>
          
          <Link
            to="/"
            className="w-full btn btn-secondary"
          >
            <Upload className="h-5 w-5 mr-2" />
            Upload a File
          </Link>
        </div>
        
        <div className="mt-8 text-sm text-gray-500">
          <p>If you believe this is an error, please check the URL or contact support.</p>
        </div>
      </div>
    </div>
  );
} 